import React, { useState, useEffect, useMemo, useContext } from 'react';
import Likert from '../../../Charts/Likert/Likert';
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import GroupReportContext from '../../../../Context/GroupReportContext';

const CollabrativeImg = require("../../../../Assets/Images/COLLABORATIVE.png");
const VisionaryImg = require("../../../../Assets/Images/VISIONARY.png");
const StrategicImg = require("../../../../Assets/Images/STRATEGIC.png");
const PerformanceImg = require("../../../../Assets/Images/PERFORMANCE.png");
const HeartIcon = require("../../../../Assets/Images/Heart-Icon.png");
const StrengthIcon = require('../../../../Assets/Images/STRENGTH.png');
const SoulIcon = require('../../../../Assets/Images/SOUL.png');
const MindIcon = require('../../../../Assets/Images/MIND.png');

const AlignmentFlowFirst360 = ({ apiData, reportType, pageNumber }) => {
  const { averagePercentages, averagePercentagesLeadership } = useContext(GroupReportContext)

  const [percentages, setPercentages] = useState({})

  const styles = {
    page: { paddingTop: "16px", backgroundColor: '#FFFFFF', fontFamily: "Helvetica" },
    header: { display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #00577D', paddingBottom: 5, marginBottom: '2px', marginTop: '-15px', fontFamily: "Helvetica" },
    titleMain: { fontSize: '12px', fontWeight: '700', color: '#76A3BE' },
    title: { fontSize: '11px', fontWeight: '200', color: '#76A3BE' },
    rightSection: { textAlign: 'right' },
    rightText: { fontSize: '8px', fontWeight: '700', color: '#76A3BE' },
    headerText: { fontSize: '14px', fontWeight: '700', color: '#00577D', margin: 0 },
    headerSubText: { fontSize: '11px', fontWeight: '400', color: '#C99212', margin: 0, marginTop: "2px" },
    paragraphContainer: { marginTop: "16px" },
    curiousSection: { color: "#000" },
    curiousSectionHeader: { fontSize: "10px", fontWeight: "700" },
    curiousParagraph: { fontSize: "10px" },
    curiousSectionNote: { fontWeight: "700", color: "#000", fontSize: "10px", margin: "16px 0px",  },
    vsSection: { fontWeight: "700", color: "#00577D", fontSize: "11px", textAlign: "center" },
    paragraph: { fontSize: '10px', fontWeight: '400', color: '#000',  margin: "16px 0px", lineHeight: '14px', letterSpacing: 0 },
    chart: { width: '100%', maxWidth: '510px', height: 'auto', display: 'block', margin: '20px auto' },
    footer: { display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #00577D', paddingTop: 10, marginTop: 20 },
    footerTextHeading: { fontSize: '12px', fontWeight: '700', color: '#76A3BE' },
    footerText: { fontSize: '10px', color: '#76A3BE' },
    chartHead: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '80px' },
    chartheading: { fontFamily: 'Helvetica', fontWeight: 700, fontStyle: 'normal', fontSize: '8px', lineHeight: '12px', letterSpacing: '0%', color: '#000000', verticalAlign: 'middle', leadingTrim: 'cap-height' },
    percentages: { display: 'flex', flexDirection: 'row', position: 'relative', paddingBottom: '22px', width:"86%", margin: "0px auto" },
    percentTwentyLeft: { textAlign: 'center', position: 'absolute', left: 'calc(40%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    percentFourtyLeft: { textAlign: 'center', position: 'absolute', left: 'calc(31%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    percentSixtyLeft: { textAlign: 'center', position: 'absolute', left: 'calc(22.5%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    percentEightyLeft: { textAlign: 'center', position: 'absolute', left: 'calc(14.5%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    percentHundreadLeft: { textAlign: 'center', position: 'absolute', left: 'calc(4%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    
    percentTwentyRight: { textAlign: 'center', position: 'absolute', right: 'calc(38.5%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    percentFourtyRight: { textAlign: 'center', position: 'absolute', right: 'calc(29.5%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    percentSixtyRight: { textAlign: 'center', position: 'absolute', right: 'calc(21%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    percentEightRight: { textAlign: 'center', position: 'absolute', right: 'calc(12.5%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    percentHundreadRight: { textAlign: 'center', position: 'absolute', right: 'calc(3%)', fontSize: '8px', marginTop: "5px", color: "#000000" , },
  };

  useEffect(() => {
    const calculatedPercentages = {
      twentyLeft: 20, // Replace with dynamic logic
      fourtyLeft: 40, // Replace with dynamic logic
      sixtyLeft: 60, // Replace with dynamic logic
      eightyLeft: 80, // Replace with dynamic logic
      hundreadLeft: 100, // Replace with dynamic logic
      
      twentyRight: 20, // Replace with dynamic logic
      fourtyRight: 40, // Replace with dynamic logic
      sixtyRight: 60, // Replace with dynamic logic
      eightyRight: 80, // Replace with dynamic logic
      hundreadRight: 100, // Replace with dynamic logic
    };
    setPercentages(calculatedPercentages);
  }, [apiData]);



  const strength = averagePercentages?.find((el) => el?.name == "Strength")?.avg
  const heart = averagePercentages?.find((el) => el?.name == "Heart")?.avg
  const soul = averagePercentages?.find((el) => el?.name == "Soul")?.avg
  const mind = averagePercentages?.find((el) => el?.name == "Mind")?.avg

  const strategic = averagePercentagesLeadership?.find((el) => el?.name == "Strategic")?.avg
  const visionary = averagePercentagesLeadership?.find((el) => el?.name == "Visionary")?.avg
  const collaborative = averagePercentagesLeadership?.find((el) => el?.name == "Collaborative")?.avg
  const performance = averagePercentagesLeadership?.find((el) => el?.name == "Performance")?.avg

  const pairedResults = [
    {
      "label": "Heart",
      "pairedLabel": "Collaborative",
      "score1": heart,
      "score2": collaborative,
      "colors": [
        "#B6111F",
        "#DB888F"
      ]
    },
    {
      "label": "Soul",
      "pairedLabel": "Visionary",
      "score1": soul,
      "score2": visionary,
      "colors": [
        "#00577D",
        "#80ABBE"
      ]
    },
    {
      "label": "Mind",
      "pairedLabel": "Strategic",
      "score1": mind,
      "score2": strategic,
      "colors": [
        "#426B88",
        "#A0B5C3"
      ]
    },
    {
      "label": "Strength",
      "pairedLabel": "Performative",
      "score1": strength,
      "score2": performance,
      "colors": [
        "#C99212",
        "#E4C988"
      ]
    },
  ]

  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview apiData={apiData} />
      <div style={styles.page}>
        <div>
          <div style={styles.container}>
            <h1 style={styles.headerText}>GAP ANALYSIS</h1>
            <h3 style={styles.headerSubText}>Gap Awareness, Alignment, & Integration</h3>
          </div>

          <div style={styles.paragraphContainer}>
            <p style={styles.paragraph}>Comparing your Starter Quadrant and Flow Type™ with your Leadership Style and Leadership Flow™ helps reveal something essential: Are you leading from your design or from adaptation?</p>
            <p style={styles.paragraph}>Sometimes there is alignment. Who you are matches how you lead. Other times there is a gap between your wiring and the style you use.</p>
            <p style={styles.paragraph}>A gap is not automatically a problem. Some gaps are intentional and serve the role, the culture, or the season you are in. These gaps work as long as you know why they exist and how to return to your natural strengths when the pressure shifts. Other gaps are unintentional. They often reflect environments you adapted to, a past season that required survival, or a version of success that never fully fit.</p>
            <p style={{ ...styles.paragraph }}>Most leaders do not drift on purpose. Over time, we adjust to what is expected, rewarded, or simply needed. The cost shows up later as burnout, misalignment, or the feeling that you are wearing someone else’s armor.</p>
          </div>

          <div style={styles.curiousSection}>
            <h3 style={styles.curiousSectionHeader}>Alignment Flow invites you to pause and get curious:</h3>
            <p style={styles.curiousParagraph}>1. Where am I compensating instead of leading from strength?</p>
            <p style={styles.curiousParagraph}>2. What part of me have I sidelined to stay successful?</p>
            <p style={styles.curiousParagraph}>3. Does my leadership still reflect who I am—or just who I’ve needed to be?</p>
          </div>

          <p style={styles.curiousSectionNote}>The more aligned your leadership becomes, the more consistent your communication, expectations, and outcomes become.</p>
          <p style={styles.vsSection}>WHO YOU ARE vs HOW YOU LEAD</p>
          
          {/* <img src={Chart} alt="Gap Analysis Chart" style={styles.chart} /> */}
          <div style={styles.chartHead}>
            <p style={styles.chartheading}>WHO YOU ARE</p>
            <p style={styles.chartheading}>HOW YOU LEAD</p>
          </div>
          {pairedResults.map(({ label, pairedLabel, score1, score2, colors }) => (
            <Likert
              key={label}
              left_labels={[{ label, color: colors[0] }]}
              right_labels={[{ label: pairedLabel, color: colors[1] }]}
              responses={{
                total: 100,
                data: {
                  [label]: score1,
                  [pairedLabel]: score2
                }
              }}
            />
          ))}
          <div style={styles.percentages}>
            <p style={styles.percentTwentyLeft}>{percentages.twentyLeft}%</p>
            <p style={styles.percentFourtyLeft}>{percentages.fourtyLeft}%</p>
            <p style={styles.percentSixtyLeft}>{percentages.sixtyLeft}%</p>
            <p style={styles.percentEightyLeft}>{percentages.eightyLeft}%</p>
            <p style={styles.percentHundreadLeft}>{percentages.hundreadLeft}%</p>

            <p style={styles.percentTwentyRight}>{percentages.twentyRight}%</p>
            <p style={styles.percentFourtyRight}>{percentages.fourtyRight}%</p>
            <p style={styles.percentSixtyRight}>{percentages.sixtyRight}%</p>
            <p style={styles.percentEightRight}>{percentages.eightyRight}%</p>
            <p style={styles.percentHundreadRight}>{percentages.hundreadRight}%</p>
          </div>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
};

export default AlignmentFlowFirst360;